<template>
  <div class="home">
	    <div class="box">	
            <div class="notification is-warning" v-if="loading === true">
                Loading ...
            </div>
            <form @submit.prevent="saveAward" v-if="loading===false">
                    
                    <div class="field">
                        <label class="label">Email</label>
                        <div class="control">
                            <input class="input" type="email" v-model="volunteer.email" required>
                            <small><input type="checkbox" v-model="send_email" value="1" /> send the certificate by email as a PDF</small>
                        </div>
                    </div>
                    
                    <div class="field">
                        <label class="label">EPIC Award</label>
                        <div class="control">
                            <select class="input" v-model="award" required>
                              <option value="">Please select</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                              <option value="200">200</option>
                            </select>
                            
                        </div>
                    </div>

                    <div class="field">
                        <label class="label">Name on Certificate</label>
                        <div class="control">
                            <input class="input" type="text" v-model="certificate_name" required maxlength="65">
                           
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Organisation on Certificate</label>
                        <div class="control">
                            <input class="input" type="text" v-model="certificate_organisation" required maxlength="65">
                           
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Signature on Certificate (Line 1)</label>
                        <div class="control">
                            <input class="input" type="text" v-model="certificate_signature" required maxlength="45">
                           
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Signature Line 2</label>
                        <div class="control">
                            <input class="input" type="text" v-model="certificate_signature_2"  maxlength="45">
                           
                        </div>
                    </div>

                    <div class="field" >
                        <label class="label">Signature Line 3</label>
                        <div class="control">
                            <input class="input" type="text" v-model="certificate_signature_3"  maxlength="45">
                           
                        </div>
                    </div>

                    <div class="field" >
                        <label class="label">Volunteer Centre on Certificate</label>
                        <div class="control">
                            <input class="input" type="text" v-model="certificate_centre_name" required maxlength="45">
                           
                        </div>
                    </div>

                     <div class="field" >
                        <label class="label">Date on Certificate</label>
                        <div class="control">
                            <input class="input" type="text" v-model="certificate_date" required maxlength="50">
                           
                        </div>
                    </div>
                    

                   
                    <div class="field is-grouped">
                        <div class="control">
                            <button class="button is-success" :disabled="loading===true">Save EPIC Award</button>
                             <button type="button" class="button is-warning ml-3" :disabled="loading===true" @click="preview()">Preview</button>
                        </div>
                    </div>
                </form>
          
        </div>
		
	</div>
</template>

<script>
import AwardsService from '@/services/AwardsService.js';
import AwardsMixin from '@/mixins/AwardsMixin.js';

import axios from "axios"

export default {
  name: 'AddAward',
	mixins: [AwardsMixin],
	data: function () {
    	return {
		      loading : true,
			  search: "",
				API_NAME: process.env.VUE_APP_API_NAME,
				accessToken: '',
        
        award: '',
        email: '',
        send_email: 1,
        volunteer: [],
        certificate_name: '',
        certificate_organisation: '',
        certificate_signature: '',
        certificate_signature_2: '',
        certificate_signature_3: '',
        certificate_centre_name: '',
        certificate_date: new Date().toLocaleDateString(),
        user: ''
		}
	},
	created() {
      this.getAccessToken()
        .then(() => { 
           this.getVolunteer();
           this.getUserProfile();
		
        });
      
    },
	methods: {
		async getAccessToken() {
            this.accessToken = await this.$auth.getTokenSilently()
        },
		// Log the user in
		login() {
			this.$auth.loginWithRedirect();
		},
		async saveAward() {
			

            if(this.award == null || this.award == '')
            {
                alert("Please select the award");
                return false;
            }
            else{
                this.loading = true;

                var formdata = { 
                   award : this.award,
                    email : this.volunteer.email,
                    send_email : this.send_email,
                    
                  certificate_name : this.certificate_name,
                  certificate_organisation : this.certificate_organisation,
                  certificate_signature : this.certificate_signature,
                  certificate_signature_2 : this.certificate_signature_2,
                  certificate_signature_3 : this.certificate_signature_3,
                  certificate_centre_name : this.certificate_centre_name,
                  certificate_date : this.certificate_date,
                  user_id: this.$route.params.id
                }; 

                AwardsService.saveAward(this.accessToken, formdata)
                .then((response) => {
                    this.$router.push("/volunteers/" + this.$route.params.id);
                    console.log(response)
                    this.loading = false;
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                        this.loading = false;
                });
            }

			
		},
            preview() {
                 if(this.award == null || this.award == '')
                {
                    alert("Please select the award");
                    return false;
                }
                else{
                   var formdata = { 
                        award : this.award,
                         
                            
                        certificate_name : this.certificate_name,
                        certificate_organisation : this.certificate_organisation,
                        certificate_signature : this.certificate_signature,
                        certificate_signature_2 : this.certificate_signature_2,
                        certificate_signature_3 : this.certificate_signature_3,
                        certificate_centre_name : this.certificate_centre_name,
                         certificate_date : this.certificate_date,
                        user_id: this.$route.params.id
                    }; 

                    var uri = this.API_NAME + "/epic_awards/preview"
                axios({
                            url: uri,
                            method: 'POST',
                            responseType: 'blob', // important
                            data: formdata,
                            headers: {
                            Authorization: `Bearer ${this.accessToken}`
                            }
                
                        }).then(function (response) {
                                const url = window.URL.createObjectURL(new Blob([response.data]));
                                const link = document.createElement('a');
                                link.href = url;
                                
                                //link.innerText = "Click here";
                                link.setAttribute('download', 'preview.pdf');
                                document.body.appendChild(link);
                                link.click();

                        })
                        .catch(function (error) {
                            console.log(error)
                        });
                }
            }
		
		
	},
    watch: {
        // whenever question changes, this function will run
        volunteer:function(val) {
            this.certificate_name = val.forename + ' ' + val.surname;
           
        },
        user:function(val) {
            this.certificate_centre_name = val.companies[0].name;
           this.certificate_signature = val.companies[0].default_signature;
        },
    },
    
}
</script>
